export default __webpack_public_path__ + "static/media/catalogue1.086bb19c.jpg";